import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordConfirmValidator(
  passwordKey = 'password',
  confirmKey = 'passwordConfirm',
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordKey);
    const passwordConfirm = group.get(confirmKey);

    if (password?.value !== passwordConfirm?.value) {
      passwordConfirm?.setErrors(
        { passwordConfirmMatches: false },
        { emitEvent: false },
      );
    } else {
      passwordConfirm?.setErrors(null, { emitEvent: false });
    }
    return null;
  };
}
